import React from 'react';
import Select from '../../../components/ui/Select';
import AgentStatusIndicator from '../../../components/AgentStatusIndicator';

const AgentSelector = ({ selectedAgent, onAgentChange, agents }) => {
  const agentOptions = agents?.map(agent => ({
    value: agent?.id,
    label: agent?.name,
    description: agent?.description,
    disabled: agent?.status === 'offline'
  }));

  return (
    <div className="space-y-2">
      <Select
        label="Select Target Agent"
        description="Choose which agent will receive your message"
        placeholder="Choose an agent..."
        options={agentOptions}
        value={selectedAgent}
        onChange={onAgentChange}
        required
        searchable
        className="w-full"
      />
      {selectedAgent && (
        <div className="flex items-center gap-3 p-3 bg-muted/30 rounded-lg">
          <AgentStatusIndicator 
            status={agents?.find(a => a?.id === selectedAgent)?.status || 'offline'}
            agentName={agents?.find(a => a?.id === selectedAgent)?.name || ''}
            size="default"
            showLabel={true}
            showIcon={true}
          />
          <p className="text-sm text-muted-foreground">
            {agents?.find(a => a?.id === selectedAgent)?.statusMessage || ''}
          </p>
        </div>
      )}
    </div>
  );
};

export default AgentSelector;